/**
 * API/JSON sometimes yields the literal strings "null" / "undefined", which are truthy in JS but invalid persona tokens.
 */
export function isUsablePersonaId(
  personaId: string | null | undefined,
): personaId is string {
  if (personaId == null || personaId === "") return false;
  if (personaId === "null" || personaId === "undefined") return false;
  return true;
}
